import { render, staticRenderFns } from "./PurchaseGalleryProvider.vue?vue&type=template&id=98c9a886&scoped=true&"
import script from "./PurchaseGalleryProvider.vue?vue&type=script&lang=ts&"
export * from "./PurchaseGalleryProvider.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseGalleryProvider.vue?vue&type=style&index=0&id=98c9a886&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c9a886",
  null
  
)

export default component.exports